<template>
  <div>
    <div class="h-fit  -mt-6 px-4" v-if="loaded" id="heatmapchart">
      <vue-apex-charts type="heatmap" class=" z-0  overflow-x-scroll sm:overflow-x-hidden  overflow-y-hidden " width="660" :height="height" :options="chartOptions" :series="series.slice().reverse()"></vue-apex-charts>
    </div>
  </div>
</template>



<script setup>
import VueApexCharts from "vue3-apexcharts";
import {ref, defineProps, onMounted, watch, defineEmits} from "vue";
import ApiService from "@/services/ApiService";
let apiService = new ApiService();
import {useApiStore} from "@/stores/ApiStore";
const emit = defineEmits(["dataLoaded"])

const apiDataStore = useApiStore();

let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})
let loaded = ref(false);
let height = ref(250);
let test = ref()

onMounted( async () => {
  if (screen.width < 625 && props.hasLongTitle){
    height.value = 200;
  }
  else if (screen.width < 625 && !props.hasLongTitle){
    height.value = 230;
  }
  getWeekdays();
  await refreshData();
})


watch(() => props.update, () => {
  refreshData();
})

let apiDataset = ref();
let hourAbbreviation = ref();
let subject = ref();
async function refreshData() {
  let apiData = await apiService.get(props.source);
  apiDataset.value = apiData.data
  hourAbbreviation.value = apiData.hourAbbreviation;
  subject.value = apiData.subject
  emit("dataLoaded")
  loaded.value = false
  series.value = [];
  fillSeries()
  formatData(apiDataset.value);
  initHeatmap();

  loaded.value = true;
  test.value =weekdays.value.slice().reverse()
}

let monday = ref([]);
let tuesday = ref([]);
let wednesday = ref([]);
let thursday = ref([]);
let friday = ref([]);
let saturday = ref([]);
let sunday = ref([]);


let series = ref([])
let data =ref( [monday, tuesday, wednesday, thursday, friday, saturday, sunday])


function fillSeries(){
  data.value.forEach(serie => {
    serie.value = [];
    let i = 0
    while( i < 24){
      serie.value.push({'x': i.toString(), 'y': 0})
      i ++
    }
  })
}

let weekdays = ref([]);

function getWeekdays(){
  weekdays.value = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(null, 0, i +1);
    weekdays.value[i] = date.toLocaleString(apiDataStore.getLang, { weekday: 'long' });
  }
}


function formatData(data){
  data.forEach(entry => {
    switch (entry.day){
      case 0:
        sunday.value[entry.hour] = ({'x': entry.hour.toString(), 'y': entry.value})
        break;
      case 1:
        monday.value[entry.hour] =  ({'x': entry.hour.toString(), 'y': entry.value})
        break;
      case 2:
        tuesday.value[entry.hour] =  ({'x': entry.hour.toString(), 'y': entry.value})
        break;
      case 3:
        wednesday.value[entry.hour] = ({'x': entry.hour.toString(), 'y': entry.value})
        break;
      case 4:
        thursday.value[entry.hour] =  ({'x': entry.hour.toString(), 'y': entry.value})
        break;
      case 5:
        friday.value[entry.hour] = ({'x': entry.hour.toString(), 'y': entry.value})
        break;
      case 6:
        saturday.value[entry.hour] =  ({'x': entry.hour.toString(), 'y': entry.value})
    }
  })
}

function initHeatmap(){
  let i = 0;
  for(i in weekdays.value){
    series.value.push({"name":weekdays.value[i], "data": data.value[i]})
  }
}


let chartOptions = ref( {
  chart: {
    toolbar: {
      show: false
    },
    fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
  },
  plotOptions: {
    heatmap: {
      radius: 2,
      shadeIntensity: 1,
      colorScale: {
        ranges: [{
          from: 0,
          to: 0,
          color: '#F8F8F8'
        }]
      }
    }
  },
  xaxis: {
    labels:{
      // offsetX: -4,
      style: {
        fontSize: '10px',
      }
    }
  },
  yaxis: {
    labels: {
      offsetX: -8,
      formatter: function(str) {
        let n = 4
        if (apiDataStore.getLang === 'nl'){
          n = 3
        }
        return str.length > n ? str.substr(0, n - 1) : str
      }
    }
  },
  dataLabels: {
    enabled: false
  },
  legend:{
    show: false
  },
  tooltip:{
    custom: function({ seriesIndex, dataPointIndex, w}) {
      let day = test.value[seriesIndex]
      let value = w['globals']['series'][seriesIndex][dataPointIndex]
      let hour = dataPointIndex
      let nextHour = parseInt(dataPointIndex) +1
      return `<div style="background-color: rgba(0, 0, 0, 0.8);color: white; padding-left: 0.2rem; padding-right: 0.2rem; font-size: 0.6rem" class="flex flex-col">
        <p>
            ${day +" " + hour + hourAbbreviation.value+ " - " + nextHour+hourAbbreviation.value}
        </p>
        <p style="font-weight: bold">
            ${ subject.value + ": " + value}
        </p>
        </div>`
    }
  },
  colors: [props.colorPalette.barGraphPrimary],
})

</script>

<style>
.tooltipcomponent {
  position: relative;
  display: inline-block;
}

.tooltipcomponent .tooltiptext {
  visibility: hidden;
  width: 200px;
  background-color: gray;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  z-index: 1;

  /* Fade in tooltip - takes 1 second to go from 0% to 100% opac: */
  opacity: 0;
  transition: opacity 0.5s;
}


/*.tooltipWideWidget .tooltiptextWideWidget {*/
/*  left: 30%;*/
/*  top: -3rem;*/
/*}*/

.tooltipcomponent:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

#heatmapchart {
  z-index: 12;
}
</style>

<style scoped>
::-webkit-scrollbar:horizontal {
  height: 12px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, .5);
  border-radius: 10px;
  border: 2px solid #ffffff;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}

</style>
